<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <a-form-item
        label="父级路由"
        name="parent_menu_id"
        extra="选择父级菜单；留空表示顶级菜单。保存时会直接写到该视图对应的菜单行"
      >
        <!-- ★ v29.45（用户定案）：父级从「state 字符串」改为 **Menu.id**。
             旧版写 `parent_menu_flag`（存父菜单的 state 原值），需要在保存时把 state 解析成 id；
             现在 `save_view` 直接写 `Menu.parent_id`，不再需要转换，
             取值口径与 menuConfig.vue 的父级菜单选择器也统一成 id。 -->
        <RemoteTreeSelectPro
          v-model:value="model.parent_menu_id"
          :form-model="model"
          placeholder="请选择父级菜单"
          value-key="id"
          label-key="name"
          :field="{
            placeholder_i18n: '请选择父级菜单',
            name: 'parent_menu_id',
            allowClear: true,
            valueKey: 'id',
            labelKey: 'name',
            placeholder: '请选择父级菜单',
            postUrl: '/permission/query_menu_list__tree',
            span: 12,
          }"
          :allow-clear="true"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item
        label="隶属项目"
        name="menu_project"
        extra="该视图菜单归属的模块/项目；留空 = 通用（所有项目可见）。同样同步到菜单行"
      >
        <!-- ★ v29.13：照 menuConfig 的 menu_project，postUrl 取语言项目表（值域 = 各宿主项目 flag） -->
        <RemoteSelectPro
          v-model:value="model.menu_project"
          :form-model="model"
          value-key="project"
          label-key="name"
          placeholder="请选择模块"
          :field="menuProjectField"
        />
      </a-form-item>
    </a-col>
    <a-col :span="24">
      <div class="step-menu-tip">
        本步两项在保存时<b>直接写入该视图对应的菜单行</b>（菜单不存在则自动新建）；
        菜单的<b>可见角色</b>请在「菜单管理」里配该菜单的角色授权 —— SQL 视图自身已不再保存角色信息。
      </div>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import RemoteTreeSelectPro from 'liyu-pc-base/components/FormRender/RemoteTreeSelectPro/RemoteTreeSelectPro.vue';
import RemoteSelectPro from 'liyu-pc-base/components/FormRender/RemoteSelectPro/RemoteSelectPro.vue';

/* ★ v29.45（用户定案）：原「菜单与权限」步（Step 2）挪到**最后一步**并改名「菜单」，
   同时裁掉两项：
     · 菜单索引（sort）  → 改由后端在**新建菜单时**取 `max(sort) + 1`，视图侧不再配置
     · 可见角色（roles）  → 改由「菜单的角色授权」承载，`DbView` 不再有角色概念
   只留「父级路由」与「隶属项目」，两者由 `save_view` 同步到该视图对应的菜单行。

   拆分约定同其它步骤：`model` 由外壳持有、按对象引用共享，这里用 computed 取用后直接改属性。 */

interface Props {
  model: any;
}
const props = defineProps<Props>();

const model = computed(() => props.model);

/* ★ v29.13：menu_project 的 RemoteSelectPro 字段配置（照 menuConfig 同款；
   Field 接口必填属性多、模板内联对象字面量会被 TS 判缺属性，这里用 any 放宽） */
const menuProjectField: any = {
  name: 'menu_project',
  show_search: true,
  mode: 'default',
  postUrl: '/i18n/query_language_project_list',
};
</script>

<style scoped lang="less">
/* 说明文案：与各 a-form-item 的 extra 同色（次要文字），整行铺开 */
.step-menu-tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 20px;
}
</style>
